// extracted by mini-css-extract-plugin
module.exports = {"LinkButton":"dist-es__LinkButton__LinkButton","LinkButton__anchor":"dist-es__LinkButton__LinkButton__anchor","LinkButton_neutral":"dist-es__LinkButton__LinkButton_neutral"};